"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _getPropSelector = _interopRequireDefault(require("./getPropSelector"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const viewPropTypes = {
  pointerEvents: _propTypes.default.oneOf(['all', 'none', 'box-only', 'box-none']),
  onLayout: _propTypes.default.func,
  nativeID: _propTypes.default.string,
  testID: _propTypes.default.string,
  dataSet: _propTypes.default.object
};
var _default = exports.default = {
  /**
   * Subset of `View` proptypes that could conceivably be needed on any component
   * that renders a single View.
   */
  types: viewPropTypes,
  /**
   * Filters a props object, returning only cross-platform View props that are potentially
   * relevant to any basic layout component that renders one View.
   */
  select: (0, _getPropSelector.default)(viewPropTypes)
};